import React, { useEffect } from "react";
import no_data from "../../assets/images/no_data_found.png";
import classes from "./EmptyState.module.css";
import { getAllFlashProducts } from "../../services/products";
import useHttp from "../../hooks/use-http";
import LoadingSpinner from "../ui/loadingSpinner/LoadingSpinner";
import ProductCard from "../ui/productCard/ProductCard";

/**
 * Professional Reusable Empty State fetching real API items directly
 */
const EmptyState = ({
  title = "We're Sorry...",
  message = "We seem to have lost this page but we don't want to lose you.",
  showButton = true,
}) => {
  const {
    sendRequest,
    status,
    data: products,
    error,
  } = useHttp(getAllFlashProducts, true);

  useEffect(() => {
    sendRequest();
  }, [sendRequest]);

  return (
    <div className={classes.pageWrapper}>
      {/* 1. Header Information Banner Block (Inspired by image_2c71fd.jpg) */}
      <div className={classes.messageContainer}>
        <div className={classes.iconBox}>
          <img width={200} loading="lazy" src={no_data} alt="" />
        </div>
        <h3 className={classes.title}>{title}</h3>
        <p className={classes.message}>{message}</p>

        {/* Call to action navigation component back up button */}
        {showButton && (
          <button
            onClick={() => (window.location.href = "/")}
            className={classes.homeBtn}
          >
            Back to homepage
          </button>
        )}
      </div>

      {status === "pending" && (
        <div className={classes.loaderContainer}>
          <LoadingSpinner />
        </div>
      )}

      {/* State B: Error State handles network failures gracefully */}
      {/* {error && <div className="centered focused">{error}</div>} */}

      {/* State C: Success path maps responsive multi-column layout grid structures wrapper */}
      {status === "completed" && products && products.length > 0 && !error && (
        <div className={classes.suggestionsSection}>
          <h4 className={classes.sectionHeader}>Just For You</h4>
          <div className={classes.productGrid}>
            {products.slice(0, 6).map((product) => (
              <ProductCard
                catId={product.categoryId}
                key={product.productId}
                prodId={product.productId}
                prodThumbnail={product.thumbnail}
                prodTitle={product.title}
                prodPrice={product.price}
                prodOldPrice={product.old_price}
                prodDiscountPct={product.discount_in_percent}
                prodRating={product.productRating}
              />
            ))}
          </div>
        </div>
      )}

      {/* {status === "completed" && (!products || products.length === 0) && (
          <p className="centered">
            No product suggestions available right now.
          </p>
        )} */}
    </div>
  );
};

export default EmptyState;
